export function recordToArray<T>(record: Record<any, T>): T[] {
  return Object.keys(record).map((key) => record[key]);
}
